import { Message } from 'element-ui'

export function sendNetworkFailedMessage () {
  Message({
    message: '当前网络异常，请稍后重试',
    type: 'error'
  })
}

export function sendTimeRangeSelectFailedMessage () {
  Message({
    message: '时间跨度必须为1天~6个月，请重新选择',
    type: 'error'
  })
}

export function sendTimeRangeSelectFutureMessage () {
  Message({
    message: '不支持选择未来时间，请重新选择',
    type: 'error'
  })
}

export function sendOperationSuccessMessage () {
  Message({
    message: '操作成功',
    type: 'success'
  })
}

// type: success, error, warning, info
export function sendMessage (message, type) {
  Message({
    message,
    type
  })
}
